import React from "react";
import { RadioOptionRow, RadioIconContainer, RadioIcon, RadioOptionText } from "./styled";
var defaultRenderer = function (optionRow) {
    var checked = optionRow.checked, label = optionRow.option.label;
    return (React.createElement(RadioOptionRow, { defaultRenderer: true },
        React.createElement(RadioIconContainer, null,
            React.createElement(RadioIcon, { checked: checked })),
        React.createElement(RadioOptionText, { flush: true }, label)));
};
export default defaultRenderer;
